exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n@media (max-width: 600px){\n#title[data-v-ea6410a4] .display-1{\r\n    font-size: 1.9em !important;\n}\n}\n.bold-title[data-v-ea6410a4] {\r\n  font-weight: bold !important;\n}\r\n", ""]);

